import { useState, useEffect, useContext } from 'react';
import { DeviceClassContext } from 'src/core/engine/deviceClass';

// Width assumed before the first measurement, matching the layout SSR rendered for.
const DESKTOP_GUESS_WIDTH = 1280;

export const useViewport = (mobileWidth?: number) => {
    const device = useContext(DeviceClassContext);
    const [width, setWidth] = useState(() => (device === 'desktop' ? DESKTOP_GUESS_WIDTH : 0));
    const mobileViewport = mobileWidth || 700;
    const tabletViewport = 1024;

    useEffect(() => {
        const handleWindowResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleWindowResize);
        handleWindowResize();
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    const isMobile = width <= mobileViewport;
    const isTablet = width >= tabletViewport;

    return { isMobile, isTablet };
};
